import React from 'react';
import styled from 'styled-components';

import Layout from '@/layout';

import Header from './components/Header';
import Form from './components/Form';

export function CreditLeasingSingle() {
  return (
    <Layout>
      <Component>
        <Header />
        <Form />
      </Component>
    </Layout>
  );
}

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
